import { CoverageItems } from './CoverageItems'
import { TransportItems } from './TransportItems'

export const InformationStep = () => {
  return (
    <>
      <CoverageItems />
      <TransportItems />
    </>
  )
}
